
<script>

</script>

<template>
  <div  id="Vue-3-component-no-data-found-banner" class="data-error-message-wrapper">
    <div class="data-error-message">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>

.data-error-message-wrapper {
  background: #ffffff;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.data-error-message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 320px;
  margin: 10px auto;
  background: #fff5f5;
  border-radius: 12px;
  font-size: 16px;
  color: #111111;
  box-shadow: 1px 1px 8px 1px #d2d2d2;
  /*border-radius: 20px;*/
  /*height: 40px;*/
  /*background: var(--side-menu-color);*/
  /*color: var(--side-menu-text-color);*/
  /*font-size: 14px;*/
  /*width: max-content;*/
  /*padding: 0 20px 0 20px;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  /*display: flex;*/
}

</style>
